<template>
	<div>
		<button class="btn dm-btn-padding dm-download-materials-button"
			@click="showCannotDownloadMaterialPopup()">
			Download Material
		</button>
	</div>
</template>

<script>
export default {
	methods: {
		showCannotDownloadMaterialPopup() {
			this.$swal({
				title: "Access reserved",
				text: 'Rights might be under option or reserved in your market. For more details, contact Babel-Bridge or our associates in your territory.',
				icon: "error",
			})
		}
	}
}
</script>
